/**
 * Contrats partagés POP! — source unique de vérité des formes de données.
 *
 * Ces schémas sont la référence : le serveur valide les entrées avec eux, et le
 * frontend en dérive ses types. Aucune forme ne doit être redéclarée ailleurs.
 */
import { z } from 'zod';
/** Environnements déployables. */
export const environmentSchema = z.enum(['local', 'staging', 'production']);
/**
 * Réponse de `GET /api/autonomy-check`.
 *
 * Cette route existe pour la certification d'autonomie : elle doit renvoyer la
 * révision RÉELLEMENT déployée, afin qu'un déploiement puis un rollback soient
 * vérifiables de l'extérieur. `release` provient de l'environnement injecté par
 * la CI — jamais d'une valeur écrite en dur, sinon la route ne prouverait rien.
 */
export const autonomyCheckSchema = z.object({
    status: z.literal('ok'),
    release: z.string().min(1),
    environment: environmentSchema,
    service: z.literal('api'),
    uptimeSeconds: z.number().nonnegative(),
});
/** Réponse de `GET /api/health`. */
export const healthSchema = z.object({
    status: z.enum(['ok', 'degraded']),
    release: z.string().min(1),
    environment: environmentSchema,
    checks: z.object({
        database: z.enum(['ok', 'unavailable', 'skipped']),
        redis: z.enum(['ok', 'unavailable', 'skipped']),
    }),
});
/** Réponse de `GET /api/version`. */
export const versionSchema = z.object({
    name: z.literal('pop'),
    release: z.string().min(1),
    environment: environmentSchema,
    node: z.string(),
});
/**
 * Enveloppe d'erreur commune. Volontairement pauvre : pas de trace technique,
 * pas de détail interne — ceux-ci vivent dans Sentry, pas dans la réponse HTTP.
 */
export const errorSchema = z.object({
    error: z.string(),
    code: z.string(),
    requestId: z.string().optional(),
});
// Contrats de jeu — réexportés pour que le serveur et le frontend n'aient qu'un
// seul point d'import.
export * from './game.js';
//# sourceMappingURL=index.js.map